import { useMemo } from 'react';
var createDebounced = function (func, wait) {
    var timeout = null;
    var debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            func.apply(void 0, args);
        }, wait);
    };
    var cancel = function () {
        if (timeout) {
            clearTimeout(timeout);
        }
    };
    var flush = function () {
        if (timeout) {
            clearTimeout(timeout);
            func();
        }
    };
    return { func: debounced, cancel: cancel, flush: flush };
};
/**
 * @param func – the function to debounce
 * @param wait – the time to wait before calling the function
 * @param deps – the dependencies to watch for changes, similar to the deps in useCallback
 *
 * @returns an object with the following properties:
 * - func: the debounced function
 * - cancel: a function to cancel the debounced function
 * - flush: a function to call the debounced function immediately
 */
export var useDebouncedCallback = function (func, wait, deps) {
    if (wait === void 0) { wait = 0; }
    if (deps === void 0) { deps = []; }
    return useMemo(function () { return createDebounced(func, wait); }, deps);
};
